import type { TrainingParticipant } from "@repo/app-types/entities/trainingParticipant";
import { buildTrainingContactDisplayNames } from "@repo/app-types/helpers/utilities";
import { SmallTimeStamp } from "@repo/ui/SmallTimeStamp/smallTimeStamp";
import { TooltipHoverTarget } from "@repo/ui/tooltip/hoverTarget";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import { DateTime } from "luxon";
import { type FC, useMemo } from "react";

export interface ParticipantCellProps {
  participant: TrainingParticipant;
}

export const ParticipantCell: FC<ParticipantCellProps> = (props) => {
  const contact = props.participant.contact;
  const { primaryDisplayName, secondaryDisplayName } =
    buildTrainingContactDisplayNames(contact);

  const lastActivityDate = useMemo(
    () => DateTime.fromISO(props.participant.last_activity_at),
    [props.participant.last_activity_at],
  );

  // To avoid an excessively wide column, reserve minimal space for the title and allow it to grow into any remaining space.
  return (
    <>
      <div className="flex">
        <div className="flex w-40 flex-auto items-baseline gap-1">
          <span className="truncate font-medium">{primaryDisplayName}</span>

          <TooltipTrigger>
            <TooltipHoverTarget>
              <SmallTimeStamp timestamp={props.participant.last_activity_at} />
            </TooltipHoverTarget>
            {/* TODO: Update this tooltip when last_activity_date is no longer just the date of enrollment */}
            <SimpleTooltip>
              Enrolled {lastActivityDate.toLocaleString(DateTime.DATETIME_FULL)}
            </SimpleTooltip>
          </TooltipTrigger>
        </div>
      </div>

      <div className="flex">
        {secondaryDisplayName ? (
          <span className="w-40 flex-auto truncate text-gray-600">
            {secondaryDisplayName}
          </span>
        ) : null}
      </div>
    </>
  );
};
